export default class NewsSearch {
	constructor($) {
		this.$ = $;

		this.monthFilter = $('#news-filter-month');
		this.categoryFilter = $('#news-filter-category')
		this.keywordFilter = $('#news-filter-keyword');
		this.results = $('#news-results');
		this.endpoint = this.results.data('type') || 'news';
		this.data = {};

		this.orderby = 'date'; // title, date
		this.order = 'desc';

		this.debounceTimer;

		this.init()
	}

	init() {
		if( ! this.results.length ) return false;
		let $ = this.$;

		// preset filters based on hash
		let hash = document.location.hash.replace(/^#/, '').split('/');
		let date = hash[0];
		let category = hash.length > 1 ? hash[1] : '';

		let dateParts = date.split('-');
		let year = dateParts[0];
		let month = dateParts.length > 1 ? dateParts[1] : null;

		$('option[value="' + date + '"]', this.monthFilter).attr('selected', 'selected');
		$('option[value="' + category + '"]', this.categoryFilter).attr('selected', 'selected');

		// search on state filter change
		$(this.monthFilter).on('change', (event) => {
			this.search();
		});

		$(this.categoryFilter).on('change', (event) => {
			this.search();
		});

		$(this.keywordFilter).on('input', (event) => {
			this.debounceSearch();
		});

		// pagination controls
		$(this.results).on('click', '.page-link', (event) => {
			event.preventDefault();
			var page = $(event.currentTarget).data('page');
			this.search(page);
		});

		// perform initial search
		this.search();
	}

	setHash(date, category) {
		document.location.hash = `${date}/${category}`;
	}

	debounceSearch(page=1) {
		clearTimeout( this.debounceTimer );
		this.debounceTimer = setTimeout( () => {
			this.search(page);
		}, 500);
	}

	search(page=1) {
		let $ = this.$;

		// filters
		var date = this.monthFilter.val();
		var category = this.categoryFilter.val();
		var categories = category ? [category] : [];
		var keyword = this.keywordFilter.val();

		var dateParts = date.split('-');
		var year = dateParts.length ? dateParts[0] : '';
		var month = dateParts.length > 1 ? dateParts[1] : '';

		// set location hash to enable someone to bookmark this search
		this.setHash(date, category);

		// empty the results panel but maintain its height
		var h = $(this.results).height();

		$(this.results)
			.height(h)
			.addClass('loading')
			.prepend('<div class="ajax-results-spinner"><span class="loading-icon fas fa-spinner fa-spin"></span> Loading...</div>');


		$.ajax({
			method: 'post',
			url: window.ff_settings.site_url + '/wp-json/ff/v1/' + this.endpoint + '?html=1',
			dataType: 'json',
			data: {
				// filters
				categories: categories,
				month: month,
				year: year,
				keyword: keyword,

				orderby: this.orderby,
				order: this.order,

				// pagination
				page: page
			}
		}).done( (response) => {
			// do something with data
			this.data = response;
			$(this.results)
				.html(response.html)
				.removeClass('loading')
				.removeAttr('style');
		});
	}

}